<template>
  <v-container>
    <v-card flat color="transparent">
      <DeliveryOrPickUpSwitcher />
      <v-card-title v-once v-text="$dictionary.get('address-title')" />
      <v-card-subtitle v-once v-text="$dictionary.get('address-subtitle')" />
      <v-card-text>
        <v-alert v-if="basket" color="blue" type="info">
          {{ $dictionary.get('alert-address-1') }}<br>
          {{ $dictionary.get('alert-address-2') }}
        </v-alert>
        <AddressInput v-model="address"
                      :area="areaToDraw"
                      :show-areas="showAreas"
                      label="Введите адрес"
        />
      </v-card-text>
      <v-card-text ref="actions">
        <v-alert v-if="addressOK && point === null"
                 color="red"
                 type="info"
                 v-text="$dictionary.get('alert-address-can-not')"
        />
        <AlertTimeRange :point="addressOK ? point : null" />
        <Button v-if="canOrder"
                title="geo-save"
                :subtitle="submitSubtitle"
                @click="save"
                @click.native="$ym.do('address_save')"
        />
        <Button v-if="point === null || !addressOK"
                title="geo-ignore"
                grey
                subtitle="geo-ignore-subtitle"
                @click="save(true)"
                @click.native="$ym.do('address_clear_and_save')"
        />
        <Button v-if="pointData && !pointData.order_time_ok"
                subtitle="geo-ignore-bad-time"
                sub-button
                @click="save()"
                @click.native="$ym.do('address_ignore_bad_time')"
        />
        <Button v-if="fromCheckout"
                subtitle="go-to-checkout-adds"
                sub-button
                to="/checkout"
        />
        <Button v-if="fromShowcase && canOrder"
                subtitle="go-to-showcase-adds"
                sub-button
                to="/showcase"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable no-undef */

import AddressInput from '@/components/AddressInput';
import Button from '@/components/Button';
import AlertTimeRange from '@/components/AlertTimeRange';
import DeliveryOrPickUpSwitcher from '@/components/DeliveryOrPickupSwitcher';

export default {
  name: 'Address',
  components: { DeliveryOrPickUpSwitcher, AlertTimeRange, Button, AddressInput },
  data: () => ({
    address: null,
    point: null,
    pointPrev: 0,
    area: 0,
  }),
  computed: {
    pointData() {
      if (this.point === null) return null;
      return this.$store.state.data.points[this.point];
    },
    canOrder() {
      return this.addressOK
        && this.point !== null
        && this.pointData
        && this.pointData.order_time_ok;
    },
    submitSubtitle() {
      return this.fromCheckout ? 'geo-save-subtitle-alt' : 'geo-save-subtitle';
    },
    fromCheckout() {
      return this.$route.params.from === 'checkout';
    },
    fromShowcase() {
      if (!this.$store.state.data.address) return false;
      return this.$store.state.data.address.place_id && !this.fromCheckout;
    },
    basket() {
      return this.$store.state.basket.items.length > 0;
    },
    addressOK() {
      return !!(this.address && this.address.place_id && this.address.street_number);
    },
    showAreas() {
      return this.$store.state.data.settings.show_areas;
    },
    areaToDraw() {
      return this.$store.state.data.settings.draw;
    }
  },
  watch: {
    address() {
      this.updateConditions();
    }
  },
  mounted() {
    if (this.$store.state.data.settings.readonly) {
      this.$router.push('/showcase');
    }
    this.pointPrev = this.$store.state.data.point;
    this.loadAddress();
  },
  methods: {
    updateConditions() {
      const selected = this.$points.getPointByLocation(this.address ? this.address.location : null);
      let index = null;
      if (selected.point) {
        index = this.$store.state.data.points.findIndex(({ _id }) => _id === selected.point);
      }
      this.point = index;
      this.area = selected.area;
    },
    loadAddress() { this.address = this.$store.state.data.address; },
    save(clear) {
      if (clear === true) {
        this.address = null;
        this.point = null;
        this.area = null;
      }
      if (this.pointPrev !== this.point) {
        this.$store.commit('basket/clear');
      }
      this.$store.commit('data/mode', 'delivery');
      this.$store.commit('data/point', this.point);
      this.$store.commit('data/area', this.area);
      this.$store.commit('data/address', this.address);
      this.$store.commit('data/sections', this.$content.getFlattened());
      this.$router.push(this.fromCheckout ? '/checkout' : '/showcase');
    },
  },
};
</script>
